import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribeStatus('success');
      setEmail('');
      setTimeout(() => setSubscribeStatus('idle'), 3000);
    }
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-amber-600 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <img
              src="https://static.readdy.ai/image/0c2a217de6ebcbec293416173f5e37e1/96f7074a29f980cf7b2582fc4f6c3fbf.webp"
              alt="Golden Dry Cleaning"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm text-amber-50 leading-relaxed mb-2">Premium laundry services</p>
            <p className="text-sm text-amber-50 leading-relaxed mb-2">Eco-friendly practices</p>
            <p className="text-sm text-amber-50 leading-relaxed">Serving the community since 2010</p>
            <div className="mt-4 flex items-center gap-2">
              <i className="ri-phone-line text-lg"></i>
              <a href="tel:+918850056363" className="text-sm hover:text-amber-100 transition-colors">
                +91 88500 56363
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider mb-4 text-amber-100">NEWSLETTER</h4>
            <form onSubmit={handleSubscribe} className="mb-3">
              <div className="flex items-center border-b border-amber-400 pb-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="flex-1 bg-transparent text-white placeholder-amber-200 outline-none text-sm"
                  required
                />
                <button
                  type="submit"
                  className="ml-2 cursor-pointer"
                >
                  <i className="ri-arrow-right-line text-white text-xl"></i>
                </button>
              </div>
            </form>
            {subscribeStatus === 'success' && (
              <p className="text-xs text-amber-100">Thank you for subscribing!</p>
            )}
            <p className="text-xs text-amber-100 mt-2">Subscribe for exclusive offers and tips</p>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider mb-4 text-amber-100">QUICK LINKS</h4>
            <div className="space-y-3">
              <button
                onClick={() => scrollToSection('services')}
                className="block text-sm text-white hover:text-amber-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('pricing')}
                className="block text-sm text-white hover:text-amber-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Pricing
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="block text-sm text-white hover:text-amber-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                Contact Us
              </button>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wider mb-4 text-amber-100">FOLLOW US</h4>
            <div className="space-y-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-white hover:text-amber-100 transition-colors"
              >
                <i className="ri-instagram-line text-lg"></i>
                Instagram
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-white hover:text-amber-100 transition-colors"
              >
                <i className="ri-facebook-line text-lg"></i>
                Facebook
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-white hover:text-amber-100 transition-colors"
              >
                <i className="ri-twitter-x-line text-lg"></i>
                Twitter
              </a>
            </div>
          </div>
        </div>

        <div className="relative overflow-hidden py-12">
          <div className="text-center text-[120px] md:text-[180px] lg:text-[220px] font-bold leading-none text-amber-700/30 select-none">
            GOLDEN
          </div>
        </div>

        <div className="border-t border-amber-500 pt-8 text-center">
          <p className="text-sm text-amber-50">
            © 2024 Golden Dry Cleaning and Laundry Services. All rights reserved. | 
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="ml-1 hover:text-white transition-colors"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
